export const APPLICATION_TOKEN = "application-token"
export const IS_SUPER_ADMIN = 'is-super-admin'
export const APPLICATION_DATE_FORMAT = "DD/MM/yyyy HH:mm"
export const APPLICATION_DATE_FORMAT_SHORT = "DD/MM/yyyy"
export const APPLICATION_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://symbiote-accelerate-backend-03d92469a1a2.herokuapp.com'
// export const APPLICATION_BASE_URL = 'https://symbiote-accelerate-backend-03d92469a1a2.herokuapp.com'
